<template>
  <div class="bg-gray-500">
    <div class="w-full flex justify-center items-center p-6">
      <input
        v-model="text"
        placeholder="Enter text"
        class="p-3 outline-none w-full"
      />
      <button class="bg-slate-300 px-6 py-3" @click="sendData">Test</button>
    </div>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from "vue";
import { Howl } from "howler";
import { WEB_SOCKET_BASE_URL } from "@/api/api";
import { useWebSocket } from "@/hooks/useWebSocket";

const text = ref("");
const audioQueue = ref([]);
const isPlaying = ref(false);

const { socket, connect, disconnect } = useWebSocket(
  `${WEB_SOCKET_BASE_URL}/chat`,
  {
    maxRetries: 5,
    reconnectDelay: 2000,
    onMessage: async (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log("WebSocket received message: ", data);
        if (data.type !== "audioChunk") return;
        const base64Data = data.chunk; // Receive base64 string
        const audioChunk = base64ToArrayBuffer(base64Data);
        processAudioChunk(audioChunk);
      } catch (error) {
        console.error("Error handling audio chunk:", error);
      }
    },
    onOpen: () => {
      console.log("WebSocket connection opened.");
    },
    onClose: () => {
      console.log("WebSocket connection closed.");
    },
    onError: (error) => {
      console.error("WebSocket error:", error);
    },
  }
);

onMounted(() => {
  connect();
});

onBeforeUnmount(() => {
  disconnect();
});

const sendData = () => {
  if (text.value.trim() === "") {
    alert("Enter value");
    return;
  }

  socket.value.send(
    JSON.stringify({
      type: "text",
      question: text.value,
    })
  );
};

const base64ToArrayBuffer = (base64) => {
  const binaryString = atob(base64); // Decode base64 to binary string
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
};

const processAudioChunk = (chunk) => {
  const blob = new Blob([chunk], { type: "audio/mp3" }); // Adjust MIME type as needed
  const url = URL.createObjectURL(blob);
  audioQueue.value.push(url); // Add the audio chunk to the queue

  if (!isPlaying.value) {
    playNextAudio();
  }
};

const playNextAudio = () => {
  if (audioQueue.value.length === 0) {
    isPlaying.value = false;
    return;
  }

  isPlaying.value = true;
  const url = audioQueue.value.shift(); // Get the next chunk in the queue

  const sound = new Howl({
    src: [url],
    format: ["mp3"], // Specify format if known
    autoplay: true,
    onend: () => {
      playNextAudio(); // Play the next chunk when this one ends
    },
    onplayerror: (id, err) => {
      console.error("Error playing audio:", err);
      playNextAudio(); // Skip to the next chunk if an error occurs
    },
  });

  sound.play();
};
</script>

<style scoped></style>
